import { Box, Typography } from '@mui/material';
import { useLayoutConfig } from '@webbyx/mui';
import useTranslation from 'next-translate/useTranslation';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const ContactUs: React.FC<{ hotline: string }> = (props) => {
  const { hotline } = props;
  const { t } = useTranslation();
  const { isSiderHovered } = useLayoutConfig();
  return (
    <Box
      sx={{
        transition: 'all 0.75s',
        position: 'relative',
        paddingBottom: '2.8125rem',
        paddingX: '1.25rem',
        display: 'flex',
        flexGrow: 1,
        alignItems: 'flex-end',
      }}
    >
      <Typography
        sx={{
          visibility: isSiderHovered ? 'visible' : 'hidden',
          fontSize: '0.875rem',
        }}
      >
        {t('common:contactUsMessage1')}
        <Box component={'span'} sx={{ fontWeight: 600 }}>
          {hotline}{' '}
        </Box>
        {t('common:contactUsMessage2')}
      </Typography>
    </Box>
  );
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
export default ContactUs;
